import { render, staticRenderFns } from "./DragBox2.vue?vue&type=template&id=c078471a&scoped=true&"
import script from "./DragBox2.vue?vue&type=script&lang=js&"
export * from "./DragBox2.vue?vue&type=script&lang=js&"
import style0 from "./DragBox2.vue?vue&type=style&index=0&id=c078471a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c078471a",
  null
  
)

export default component.exports